import Title from '@/components/Title';
import { useTranslation } from 'next-i18next';
import React from 'react';
import dynamic from 'next/dynamic';
import Course from './Course';
import TeacherEvaluate from './TeacherEvaluate';

import 'swiper/css';

const Teachers = dynamic(() => import('./Teachers'), { ssr: false });

const StudyPlan = () => {
  const { t } = useTranslation(['whyWukong']);

  return (
    <div className="container mt-[100px] lg:mt-[140px] xl:mt-[200px]">
      <Title className="" innerHTML theme="colorful">
        {t('理由-学习计划')}
      </Title>
      <Teachers />
      <Course />
      <TeacherEvaluate />
    </div>
  );
};

export default StudyPlan;
